<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="container-fluid px-4" v-if="pergunta != null">
                        <!-- Header com botão voltar -->
                        <div class="row mb-4">
                            <div class="col-12">
                                <div class="header-section">
                                    <span class="txt-p txt-roxo-1 txt-w-bold txt-size-16 c-pointer" @click="voltar">
                                        <i class="fas fa-arrow-left"></i> Voltar
                                    </span>
                                </div>
                            </div>
                        </div>

                        <!-- Título e Modalidade -->
                        <div class="row mb-4">
                            <div class="col-12"> 
                                <div class="box-header-modern">
                                    <div class="header-title-section">
                                        <h1 class="page-title">{{pergunta.dsAssunto}}</h1>
                                        <div class="header-actions">
                                            <div class="modalidade-badge">
                                                <span class="modalidade-label">Modalidade</span>
                                                <span class="modalidade-value">
                                                    <i :class="pergunta.tipoPergunta.icone" class="me-2"></i>
                                                    {{pergunta.tipoPergunta.nmTipoPergunta}}
                                                </span>
                                            </div>
                                            <button class="btn btn-roxo btn-sm d-none"
                                                    v-if="pergunta.dsRespostaIA"
                                                    type="button"
                                                    @click="gerarPdf"
                                                    :disabled="gerandoPdf"
                                                    title="Gerar PDF da consulta">
                                                <i class="fas fa-file-pdf me-1"></i>
                                                {{ gerandoPdf ? 'Gerando PDF...' : 'Gerar PDF' }}
                                            </button>
                                        </div>
                                    </div>

                                    <div class="resposta resposta-rigth mt-3" v-if="pergunta.idEtapaAtual == 8">
                                        <span class="txt-p txt-size-16 txt-w-5 txt-cores-1"><i class="far fa-comment-alt me-2"></i> SISTEMA</span>
                                        <p class="fw-bold mb-2">
                                            {{mensagemProcessando}}
                                        </p>
                                        <p class="mb-2">
                                            Temos uma novidade para você: além do suporte do especialista técnico, agora você conta com uma resposta inteligente gerada por IA.
                                            <br />
                                            Em instantes, ela estará disponível para sua análise.

                                        </p>
                                        <div class="progress px-0">
                                            <div class="progress-bar progress-bar-striped progress-bar-animated bg-blue-2" role="progressbar" :aria-valuenow="timer" aria-valuemin="0" aria-valuemax="100" :style="{width: timer+'%'}"></div>
                                        </div>
                                    </div>

                                    <div class="pergunta mt-3" v-if="pergunta.idEtapaAtual == 9">
                                        <span class="txt-p txt-size-16 txt-w-5 txt-cores-1"><i class="far fa-comment-alt me-2"></i> SISTEMA</span>
                                        <p>
                                            Sua resposta inteligente já está pronta.
                                            <br />
                                            Ela atende à sua necessidade ou deseja uma validação complementar da nossa equipe técnica?
                                            <br />
                                            Se preferir, você pode encaminhar para análise especializada com apenas um clique
                                        </p>
                                        <button class="btn btn-roxo btn-sm"
                                                @click="enviaConsultor"
                                                title="Enviar para consultor">
                                            <i class="fas fa-paper-plane"></i> Enviar pergunta para equipe
                                        </button>
                                        <button class="btn btn-warning btn-sm ms-2"
                                                @click="finalizar"
                                                title="Enviar para consultor">
                                            <i class="fas fa-check"></i> Estou satisfeito
                                        </button>
                                    </div>
                                    <div class="pergunta mt-3" v-if="pergunta.idEtapaAtual == 9">
                                        <span class="txt-p txt-size-16 txt-w-5 txt-cores-1"><i class="far fa-comment-alt me-2"></i> SISTEMA</span>
                                        
                                        <p>
                                            As respostas geradas por IA não são descontadas do seu limite de utilizações — aproveite essa funcionalidade com total liberdade.
                                            <br />
                                            O prazo de atendimento da equipe técnica passa a contar a partir do envio da solicitação para análise especializada.

                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <!-- Conteúdo Principal -->
                            <div class="col-12 col-lg-9">

                                <!-- AUDIOS -->
                                <div class="box-borda-cinza mb-3" v-if="pergunta.lstPerguntaAudio && pergunta.lstPerguntaAudio.length > 0">
                                    <div class="row">
                                        <div class="col-12">
                                            <span class="txt-p txt-cores-1 txt-w-500 txt-size-16">
                                                <i class="far fa-file-audio"></i> áudios
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row mt-2 g-3">
                                        <div class="col-12 col-sm-6 col-md-4" v-for="(item,index) in pergunta.lstPerguntaAudio" :key="index">
                                            <div class="item-arquivo-audio">
                                                <span class="txt-p txt-cores-1 txt-w-bold txt-size-14 d-block mb-2" style="word-wrap: break-word; overflow-wrap: break-word;">{{item.nmArquivo}}</span>
                                                <button class="btn btn-roxo btn-sm w-100"
                                                        @click="downloadPerguntaArquivo(item.idArquivo)"
                                                        title="Download do arquivo">
                                                    <i class="fas fa-download me-1"></i>
                                                    <span>Download</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Dilatacao prazo -->
                                <div class="" v-if="pergunta.perguntaDilatacaoPrazo">
                                    <template v-if="pergunta.perguntaDilatacaoPrazo.flAceite == 'Não' && pergunta.perguntaDilatacaoPrazo.dtAceite == null && (pergunta.perguntaEtapa.nmEtapa != 'Finalizada' && pergunta.perguntaEtapa.nmEtapa == 'Cancelada')">
                                        <div class="box-borda-cinza mb-3 dilatacao-prazo">
                                            <div class="row">
                                                <div class="col-12">
                                                    <span class="txt-p txt-cores-1 txt-w-500 txt-size-16">
                                                        Dilatação de Prazo
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <p class="bold"><span class="txtApp"><i class="fa fa-calendar txtApp"></i> {{pergunta.perguntaDilatacaoPrazo.dtInclusao}} •</span> Prezado Cliente, foi solicitada uma Dilatação no prazo pelo consultor(a) {{pergunta.atendente.nmUsuario}}</p>
                                                    <hr />
                                                    <p class="bold"><span class="txtApp">Novo Prazo:</span> {{pergunta.perguntaDilatacaoPrazo.dtPrazo}}</p>

                                                    <p class="bold"><span class="txtApp">Motivo:</span> <span v-html="formatTexto(pergunta.perguntaDilatacaoPrazo.dsMotivo)"></span></p>
                                                </div>
                                                <div class="col-12">
                                                    <button type="button" class="btn btn-success bold" @click="mudarPrazo(pergunta.perguntaDilatacaoPrazo.idPerguntaDilatacaoPrazo, 'Sim')"><i class="fa fa-check"></i> Aceitar</button>
                                                    <button type="button" class="btn btn-vermelho bold" @click="mudarPrazo(pergunta.perguntaDilatacaoPrazo.idPerguntaDilatacaoPrazo, 'Não')"><i class="fa fa-times"></i> Recusar</button>
                                                </div>
                                            </div>
                                        </div>

                                    </template>
                                    <template v-if="pergunta.perguntaDilatacaoPrazo.dtAceite != null">
                                        <div class="box-borda-cinza mb-3">
                                            <div class="pergunta">
                                                <span class="txt-p txt-size-16 txt-w-5 txt-cores-1">
                                                    <i class="far fa-calendar me-2"></i>
                                                    {{pergunta.perguntaDilatacaoPrazo.dtInclusao}}
                                                    <template v-if="pergunta.perguntaDilatacaoPrazo.flAceite == 'Sim'">
                                                        Aceita a Dilatação no prazo em {{pergunta.perguntaDilatacaoPrazo.dtAceite}}
                                                    </template>
                                                    <template v-else>
                                                        Recusada a Dilatação no prazo em {{pergunta.perguntaDilatacaoPrazo.dtAceite}}
                                                    </template>
                                                </span>
                                                <p class="px-4 mt-2 txt-p txt-cores-1">
                                                    Novo Prazo: {{pergunta.perguntaDilatacaoPrazo.dtPrazo}}
                                                </p>
                                                <p class="px-4 mt-2 txt-p txt-cores-1">
                                                    Motivo: <span v-html="formatTexto(pergunta.perguntaDilatacaoPrazo.dsMotivo)"></span>
                                                </p>
                                            </div>
                                        </div>

                                    </template>
                                </div>

                                <div class="box-borda-cinza">
                                    <div class="pergunta">
                                        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
                                            <span class="txt-p txt-size-16 txt-w-5 txt-cores-1" v-if="pergunta.solicitante != null"><i class="far fa-comment-alt me-2"></i> {{pergunta.solicitante.nmUsuario}}</span>
                                            <div class="d-flex gap-2" v-if="podeEditarOuCancelar">
                                                <button class="btn btn-outline-primary btn-sm btn-editar-pergunta" type="button" @click="abrirModalEditarPergunta" title="Editar texto da solicitação">
                                                    <i class="fas fa-edit me-1"></i> Editar
                                                </button>
                                                <button class="btn btn-outline-danger btn-sm" type="button" @click="confirmarCancelarPergunta" title="Cancelar solicitação">
                                                    <i class="fas fa-times me-1"></i> Cancelar
                                                </button>
                                            </div>
                                        </div>
                                        <p class="px-4 mt-2 txt-p txt-cores-1" v-html="formatTexto(pergunta.dsPergunta)">
                                        </p>

                                        <div class="documentos-pergunta px-4 mt-3" v-if="lstPerguntaDocumento.length">
                                            <span class="txt-p txt-size-14 txt-w-5 txt-cores-1 d-block mb-2">
                                                <i class="fas fa-paperclip me-2"></i> Documentos anexados
                                            </span>
                                            <div class="d-flex flex-wrap gap-2">
                                                <button type="button"
                                                        class="btn-documento"
                                                        v-for="(item, index) in lstPerguntaDocumento"
                                                        :key="item.idPerguntaDocumento || index"
                                                        @click="downloadPerguntaDocumento(item)"
                                                        :title="'Download de ' + getNomeArquivo(item.urlArquivo)">
                                                    <i :class="getIconeDocumento(item.urlArquivo)" class="me-2"></i>
                                                    <span>{{ getNomeArquivo(item.urlArquivo) }}</span>
                                                    <i class="fas fa-download ms-2"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    

                                    <!-- FINALIZADA POR IA-->
                                    <div class="resposta resposta-rigth" v-if="pergunta.dsRespostaIA">
                                        <div class="d-flex flex-wrap align-items-center justify-content-between gap-2">
                                            <span class="txt-p txt-size-16 txt-w-5 txt-cores-1"><i class="far fa-comment-alt me-2"></i> SISTEMA</span>
                                            <button class="btn btn-roxo btn-sm"
                                                    type="button"
                                                    @click="gerarPdf"
                                                    :disabled="gerandoPdf"
                                                    title="Gerar PDF da consulta">
                                                <i class="fas fa-file-pdf me-1"></i>
                                                {{ gerandoPdf ? 'Gerando PDF...' : 'Gerar PDF' }}
                                            </button>
                                        </div>
                                        <p class="ps-4 mt-2 txt-p txt-cores-1 fw-bold">Prezado Cliente, sua solicitação foi respondida por IA</p>
                                        <div class="alert alert-warning mx-4 mt-2 mb-0 py-2" v-if="flRespostaIADesatualizada">
                                            <i class="fas fa-exclamation-triangle me-1"></i>
                                            Esta resposta foi gerada antes da última alteração do texto da solicitação.
                                        </div>

                                        <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="formatTexto(pergunta.dsRespostaIA)"></p>

                                        <template v-if="pergunta.dsReferenciaIA">
                                            <p class="ps-4 mt-2 txt-p txt-cores-1 fw-bold">Referências:</p>
                                            <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="formatTexto(pergunta.dsReferenciaIA)"></p>
                                        </template>
                                        
                                    </div>
                                    

                                    <template v-if="pergunta.atendente != null">
                                        <div class="pt-3" v-for="(item,index) in pergunta.lstPerguntaMovimento" :key="index">
                                            <template v-if="item.idEtapa == 6">
                                                <!--etapa 6-->
                                                <!-- FINALIZADA -->
                                                <div class="resposta resposta-rigth">
                                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-comment-alt me-2"></i> Prezado Cliente, sua solicitação foi finalizada pelo consultor(a) {{pergunta.atendente.nmUsuario}}</span>
                                                    <!-- lstResultadoArquivo -->

                                                    <template v-if="item.dsMovimento.indexOf('com a seguinte observação') != -1">
                                                        <hr />
                                                        <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="formatTexto(item.dsMovimento)"></p>
                                                    </template>

                                                </div>
                                                <div class="resposta resposta-rigth" v-if="pergunta.lstPerguntaMovimentoArquivo.length > 0">
                                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-file me-2"></i> Arquivos</span>
                                                    <div class="mt-2" v-for="(arquivo, index) in pergunta.lstPerguntaMovimentoArquivo" :key="index">
                                                        <button class="btn btn-roxo btn-sm"
                                                                @click="downloadPerguntaArquivo(arquivo.idArquivo)"
                                                                title="Download do arquivo">
                                                            <i class="fas fa-file-download mr-1"></i> Download
                                                        </button>
                                                    </div>


                                                </div>
                                            </template>
                                            <template v-else-if="item.idEtapa == 5">
                                                <!--etapa 5-->
                                                <!-- COMPLEMENTO -->
                                                <template v-if="index == 0">

                                                    <div class="pergunta mb-3">
                                                        <span class="txt-p txt-size-16 txt-w-5 txt-cores-1"><i class="far fa-comment-alt me-2"></i> Prezado Cliente, favor encaminhar as informações solicitadas pelo consultor(a) {{pergunta.atendente.nmUsuario}} <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span> </span>
                                                        <p class="px-4 mt-2 txt-p txt-cores-1" v-html="formatTexto(item.dsPergunta)"></p>
                                                        <form id="formComplemento" v-if="showComplemento">
                                                            <div class="form-group row">
                                                                <div class="col-md-12">
                                                                    <textarea class="form-control" rows="5" id="txt_dsMovimento" placeholder="Insira aqui as informações complementares" v-model="complemento" required></textarea>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex w-100 justify-content-end mt-2">
                                                                <button class="btn btn-roxo" @click="complementaInformacao(item.idMovimento)" type="button"><i class="fas fa-paper-plane txt-white"></i> Enviar</button>
                                                            </div>
                                                        </form>
                                                        <div v-else>
                                                            <button class="btn btn-roxo" type="button" @click="showComplemento = true"><i class="fas fa-comment-alt"></i> Complementar informação</button>
                                                        </div>
                                                    </div>
                                                    <div class="resposta resposta-rigth">
                                                        <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-circle me-2"></i> Solicitação de complemento <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span> </span>
                                                        <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="formatTexto(item.dsMovimento)"></p>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="resposta resposta-rigth">
                                                        <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-circle me-2"></i> Solicitação de complemento <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span></span>
                                                        <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="formatTexto(item.dsMovimento)"></p>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-else-if="item.idEtapa == 7">
                                                <!--etapa 7-->
                                                <!-- CANCELADA -->
                                                <div class="resposta">
                                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1" v-if="isCancelamentoPeloUsuario(item)">
                                                        <i class="fas fa-comment-alt me-2"></i> Prezado Cliente, a sua solicitação foi cancelada por você
                                                        <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span>
                                                    </span>
                                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1" v-else>
                                                        <i class="fas fa-comment-alt me-2"></i> Prezado Cliente, a sua solicitação foi cancelada pelo consultor(a) {{pergunta.atendente.nmUsuario}}
                                                        <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span>
                                                    </span>
                                                    <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="formatTexto(item.dsMovimento)"></p>
                                                </div>
                                            </template>
                                            <template v-else-if="item.idEtapa == 2">
                                                <!--etapa 2-->
                                                <!-- RETORNO -->
                                                <div class="resposta">
                                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-circle me-2"></i> Encaminhamento <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span> </span>
                                                    <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="formatTexto(item.dsMovimento)"></p>
                                                </div>
                                            </template>
                                            <template v-else-if="item.idEtapa == 4">
                                                <!--etapa 4-->
                                                <div class="resposta resposta-rigth">
                                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-comment-alt me-2"></i> SISTEMA <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span> </span>
                                                    <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="formatTexto(item.dsMovimento)"></p>
                                                </div>
                                            </template>
                                            <template v-else-if="item.idEtapa == 3">
                                                <!--etapa 3-->
                                                <div class="resposta resposta-rigth">
                                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-comment-alt me-2"></i> SISTEMA <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span> </span>
                                                    <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="formatTexto(item.dsMovimento)"></p>
                                                </div>
                                            </template>
                                            <template v-else>
                                                <!--etapa 1-->
                                                <div class="resposta">
                                                    <span class="txt-p txt-size-16 txt-w-5 txt-roxo-1"><i class="fas fa-comment-alt me-2"></i> {{pergunta.solicitante.nmUsuario}} <span class="txt-cores-1 txt-size-12">- {{formatData(item.dtMovimento)}}</span> </span>
                                                    <p class="ps-4 mt-2 txt-p txt-cores-1" v-html="formatTexto(item.dsMovimento)"></p>
                                                </div>
                                            </template>
                                        </div>
                                    </template>
                                </div>

                                <!-- Anotacoes -->
                                <div class="box-borda-cinza mt-3" v-if="pergunta.lstPerguntaAnotacao && pergunta.lstPerguntaAnotacao.length > 0">
                                    <div class="row">
                                        <div class="col-12">
                                            <span class="txt-p txt-cores-1 txt-w-500 txt-size-16">
                                                <i class="fas fa-list"></i> Anotações
                                            </span>
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-12" v-for="(item,index) in pergunta.lstPerguntaAnotacao" :key="index">
                                            <p class="item-anotacao">
                                                <span class="txt-w-bold">
                                                    {{item.dsLoginAlteracao}} -
                                                    {{formatData(item.dtInclusao)}}
                                                </span>: 
                                                <span v-html="formatTexto(item.dsAnotacao)"></span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Sidebar Direita com Informações -->
                            <div class="col-12 col-lg-3 mt-4 mt-lg-0">
                                <div class="sidebar-card">
                                    <!-- Número da Pergunta -->
                                    <div class="sidebar-section pergunta-numero">
                                        <span class="txt-p txt-cores-6 txt-w-bold txt-size-18">
                                            Pergunta n° {{id}}
                                        </span>
                                    </div>

                                    <!-- Status -->
                                    <div class="sidebar-section" v-if="pergunta.perguntaEtapa != null">
                                        <span class="txt-p txt-cores-1 txt-w-500 txt-size-12 text-uppercase d-block mb-2">Status</span>
                                        <p class="txt-p txt-size-16 txt-w-5 mb-0 txt-info" v-if="pergunta.perguntaEtapa.nmEtapa == 'Abertura' || pergunta.perguntaEtapa.nmEtapa == 'Andamento' || pergunta.perguntaEtapa.nmEtapa == 'Encaminhada'">
                                            <i class="fas fa-hourglass"></i> Aguardando atendimento
                                        </p>
                                        <p class="txt-p txt-size-16 txt-w-5 mb-0 txt-info" v-else-if="pergunta.perguntaEtapa.nmEtapa == 'Iniciada'">
                                            <i class="fas fa-hourglass"></i> Aguardando resposta
                                        </p>
                                        <p class="txt-p txt-size-16 txt-w-5 mb-0 txt-info piscando" v-else-if="pergunta.perguntaEtapa.nmEtapa == 'Complemento'">
                                            <i class="fa fa-reply ico-retorno"></i> Aguardando Retorno
                                        </p>
                                        <p class="txt-p txt-size-16 txt-w-5 mb-0 txt-sucess" v-else-if="pergunta.perguntaEtapa.nmEtapa == 'Finalizada'">
                                            <i class="fas fa-envelope"></i> Respondido
                                        </p>
                                        <p class="txt-p txt-size-16 txt-w-5 mb-0 txt-erro" v-else-if="pergunta.perguntaEtapa.nmEtapa == 'Cancelada'">
                                            <i class="fas fa-times"></i> Cancelado
                                        </p>
                                        <p class="txt-p txt-size-16 txt-w-5 mb-0 txt-info" v-else-if="pergunta.perguntaEtapa.nmEtapa == 'Processando'">
                                            <i class="fas fa-hourglass"></i> Processando resposta por IA
                                        </p>
                                        <p class="txt-p txt-size-16 txt-w-5 mb-0 txt-sucess" v-else-if="pergunta.perguntaEtapa.nmEtapa == 'Processado'">
                                            <i class="fas fa-envelope"></i> Respondida por IA
                                        </p>
                                        <p class="txt-p txt-size-16 txt-w-5 mb-0 txt-sucess" v-else-if="pergunta.perguntaEtapa.nmEtapa == 'Finalizada Usuário'">
                                            <i class="fas fa-envelope"></i> Finalizada pelo Usuário
                                        </p>
                                        <p class="txt-p txt-size-16 txt-w-5 mb-0 txt-cores-6" v-else>
                                            <i class="fas fa-sync-alt"></i> Sem dados
                                        </p>
                                    </div>

                                    <!-- Informações e Andamento -->
                                    <div class="sidebar-section">
                                        <span class="txt-p txt-cores-1 txt-w-500 txt-size-12 text-uppercase d-block mb-3">Informações e Andamento</span>

                                        <div class="info-andamento-compact">
                                            <i class="fas fa-calendar-alt"></i>
                                            <div>
                                                <span class="txt-p txt-size-11 txt-w-5 txt-cores-1 d-block">Solicitado</span>
                                                <p class="txt-p txt-size-13 txt-cores-6 txt-w-bold mb-0">{{pergunta.dtPerguntaFormat}}</p>
                                            </div>
                                        </div>

                                        <div class="info-andamento-compact" v-if="dtEncaminhamentoFormat">
                                            <i class="fas fa-paper-plane"></i>
                                            <div>
                                                <span class="txt-p txt-size-11 txt-w-5 txt-cores-1 d-block">Encaminhado</span>
                                                <p class="txt-p txt-size-13 txt-cores-6 txt-w-bold mb-0">{{dtEncaminhamentoFormat}}</p>
                                            </div>
                                        </div>

                                        <div class="info-andamento-compact" v-if="pergunta.perguntaEtapa != null">
                                            <i class="fas fa-hourglass"></i>
                                            <div>
                                                <template v-if="pergunta.perguntaEtapa.nmEtapa == 'Complemento'">
                                                    <span class="txt-p txt-size-11 txt-w-5 txt-cores-1 d-block">Aguardando complemento</span>
                                                </template>
                                                <template v-else>
                                                    <span class="txt-p txt-size-11 txt-w-5 txt-cores-1 d-block">Previsto</span>
                                                    <p class="txt-p txt-size-13 txt-cores-6 txt-w-bold mb-0">{{pergunta.dtPrazoFormat}}</p>
                                                </template>
                                            </div>
                                        </div>

                                        <div class="info-andamento-compact" v-if="pergunta.perguntaEtapa != null">
                                            <i class="fas fa-calendar" v-if="pergunta.perguntaEtapa.nmEtapa == 'Finalizada' || pergunta.perguntaEtapa.nmEtapa == 'Cancelada'"></i>
                                            <i class="fas fa-calendar-check" v-else></i>
                                            <div>
                                                <template v-if="pergunta.perguntaEtapa.nmEtapa == 'Finalizada' || pergunta.perguntaEtapa.nmEtapa == 'Cancelada'">
                                                    <span class="txt-p txt-size-11 txt-w-5 txt-cores-1 d-block">Finalizado</span>
                                                    <p class="txt-p txt-size-13 txt-cores-6 txt-w-bold mb-0">{{pergunta.dtMovimento}}</p>
                                                </template>
                                                <template v-else>
                                                    <span class="txt-p txt-size-11 txt-w-5 txt-cores-1 d-block">Última interação</span>
                                                    <p class="txt-p txt-size-13 txt-cores-6 txt-w-bold mb-0">{{pergunta.dtMovimento}}</p>
                                                </template>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Informações do Usuário -->
                                    <div class="sidebar-section" v-if="pergunta.solicitante != null">
                                        <span class="txt-p txt-cores-1 txt-w-500 txt-size-12 text-uppercase d-block mb-3">Informações do Solicitante</span>

                                        <div class="user-info-item-compact">
                                            <i class="fas fa-user"></i>
                                            <div>
                                                <span class="txt-roxo-1 txt-w-bold txt-size-12 d-block">Usuário</span>
                                                <p class="txt-cores-1 txt-size-13 mb-0 mt-1">{{pergunta.solicitante.nmUsuario}}</p>
                                            </div>
                                        </div>

                                        <div class="user-info-item-compact">
                                            <i class="fas fa-phone-alt"></i>
                                            <div>
                                                <span class="txt-roxo-1 txt-w-bold txt-size-12 d-block">Telefone</span>
                                                <p class="txt-cores-1 txt-size-13 mb-0 mt-1">{{pergunta.nrTelefoneContato}}</p>
                                            </div>
                                        </div>

                                        <div class="user-info-item-compact">
                                            <i class="fas fa-envelope"></i>
                                            <div>
                                                <span class="txt-roxo-1 txt-w-bold txt-size-12 d-block">E-mail</span>
                                                <p class="txt-cores-1 txt-size-13 mb-0 mt-1" style="word-break: break-all;">{{pergunta.solicitante.dsEmail}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <div class="container-fluid px-4" v-if="concluido">
                            <div class="row justify-content-center">
                                <div class="col-12 col-md-6 text-center py-5 my-5">
                                    <div class="empty-state">
                                        <p class="txt-h-1 txt-roxo-1">
                                            Pergunta não encontrada
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="ModalEditarPerguntaOrientacao" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content border-0">
                    <div class="modal-header">
                        <h5 class="modal-title">Editar texto da solicitação</h5>
                        <button type="button" class="btn-close" @click="fecharModalEditarPergunta" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <label class="form-label" for="dsPerguntaEdicao">Descrição da solicitação</label>
                        <div class="textarea-com-contador">
                            <textarea id="dsPerguntaEdicao"
                                      class="form-control form-textarea"
                                      rows="8"
                                      v-model="dsPerguntaEdicao"
                                      placeholder="Informe o texto da solicitação"
                                      :maxlength="temLimiteCaracteresEdicao ? limiteCaracteresEdicao : null"
                                      :class="{ 'form-textarea--excedido': descricaoEdicaoExcedeLimite }"></textarea>
                            <div class="char-counter" v-if="temLimiteCaracteresEdicao">
                                <span class="char-count-text"
                                      :class="{ 'char-count-text--excedido': descricaoEdicaoExcedeLimite }">
                                    {{ qtdCaracteresEdicao }}/{{ limiteCaracteresEdicao }}
                                </span>
                            </div>
                        </div>
                        <small class="text-muted">Somente o texto da pergunta será alterado. O prazo e a etapa permanecem os mesmos.</small>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fecharModalEditarPergunta">Fechar</button>
                        <button type="button"
                                class="btn btn-roxo"
                                :disabled="salvandoEdicao || !dsPerguntaEdicao || !dsPerguntaEdicao.trim() || descricaoEdicaoExcedeLimite"
                                @click="salvarEdicaoPergunta">
                            <i class="fas fa-save me-1"></i> Salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import { urlApi, avisoErro, avisoToast } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import Swal from 'sweetalert2'

    export default {
        name: 'Orientacao',
        components: { Header, },
        props: ['id'],
        computed: {
            hubConection() {
                return this.$store.state.hubConection
            },
            user() {
                return this.$store.state.user
            },
            podeEditarOuCancelar() {
                if (!this.pergunta || !this.user || !this.user.usuario) return false;
                const etapasPermitidas = [1, 2, 3, 9];
                const ehAutor = this.pergunta.dsLogin
                    && this.user.usuario.dsLogin
                    && this.pergunta.dsLogin.toLowerCase() === this.user.usuario.dsLogin.toLowerCase();
                return ehAutor && etapasPermitidas.includes(Number(this.pergunta.idEtapaAtual));
            },
            flRespostaIADesatualizada() {
                if (!this.pergunta || !this.pergunta.dsRespostaIA) return false;
                const movimentos = this.pergunta.lstPerguntaMovimento || [];
                return movimentos.some(m => this.isAlteracaoPeloUsuario(m));
            },
            limiteCaracteresEdicao() {
                const qtd = this.pergunta && this.pergunta.tipoPergunta
                    ? this.pergunta.tipoPergunta.qtdCaracteresPergunta
                    : null;
                if (qtd === 0 || qtd === '0') return '';
                if (qtd === null || qtd === undefined || qtd === '') return 500;
                return Number(qtd);
            },
            temLimiteCaracteresEdicao() {
                return this.limiteCaracteresEdicao !== '' && this.limiteCaracteresEdicao !== null && this.limiteCaracteresEdicao > 0;
            },
            qtdCaracteresEdicao() {
                return (this.dsPerguntaEdicao || '').length;
            },
            descricaoEdicaoExcedeLimite() {
                return this.temLimiteCaracteresEdicao && this.qtdCaracteresEdicao > this.limiteCaracteresEdicao;
            },
            lstPerguntaDocumento() {
                const lista = this.pergunta && this.pergunta.lstPerguntaDocumento
                    ? this.pergunta.lstPerguntaDocumento
                    : [];
                return lista.filter(item => item && item.urlArquivo);
            },
            dtEncaminhamentoFormat() {
                const movimentos = this.pergunta && this.pergunta.lstPerguntaMovimento
                    ? this.pergunta.lstPerguntaMovimento
                    : [];
                const encaminhamento = movimentos.find(item => item && item.dsMovimento === 'A solicitação foi encaminhada');
                if (!encaminhamento || !encaminhamento.dtMovimento) return null;
                return moment(encaminhamento.dtMovimento).format('DD/MM/YYYY [às] HH:mm');
            },
        },
        data: function () {
            return {
                pergunta: null,
                concluido: false,

                showComplemento: false,

                complemento: "",

                mensagemProcessando: "Processando pergunta...",
                timer: 0,
                intervalTimer: null,

                dsPerguntaEdicao: "",
                salvandoEdicao: false,
                gerandoPdf: false,
            }
        },
        methods: {

            voltar() {
                this.$router.go(-1)
            },

            isAlteracaoPeloUsuario(item) {
                return !!(item && item.dsMovimento && item.dsMovimento.indexOf('Pergunta alterada pelo usuário') !== -1);
            },

            isCancelamentoPeloUsuario(item) {
                return !!(item && item.dsMovimento && item.dsMovimento.indexOf('Cancelada pelo usuário') !== -1);
            },

            abrirModalEditarPergunta() {
                this.dsPerguntaEdicao = this.pergunta.dsPergunta || '';
                const el = document.getElementById('ModalEditarPerguntaOrientacao');
                if (!el) return;
                const bs = window.bootstrap || window.Bootstrap || null;
                if (bs && bs.Modal) {
                    const modal = bs.Modal.getOrCreateInstance
                        ? bs.Modal.getOrCreateInstance(el)
                        : new bs.Modal(el);
                    modal.show();
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal('show');
                }
            },

            fecharModalEditarPergunta() {
                const el = document.getElementById('ModalEditarPerguntaOrientacao');
                if (!el) return;
                const bs = window.bootstrap || window.Bootstrap || null;
                if (bs && bs.Modal) {
                    const instance = bs.Modal.getInstance(el);
                    if (instance) instance.hide();
                } else if (window.$ && typeof window.$.fn.modal === 'function') {
                    window.$(el).modal('hide');
                }
            },

            async salvarEdicaoPergunta() {
                if (!this.dsPerguntaEdicao || !this.dsPerguntaEdicao.trim()) {
                    avisoErro('Informe o texto da solicitação.');
                    return;
                }

                if (this.descricaoEdicaoExcedeLimite) {
                    avisoErro(`Para esta modalidade a descrição deverá ter no máximo ${this.limiteCaracteresEdicao} caracteres.`);
                    return;
                }

                this.salvandoEdicao = true;
                try {
                    const payload = {
                        idPergunta: this.pergunta.idPergunta,
                        dsPergunta: this.dsPerguntaEdicao.trim(),
                    };
                    const res = await axios.post(`${urlApi}/Pergunta/EditarPerguntaUsuario`, payload);

                    if (res.data && res.data.success) {
                        avisoToast('Solicitação atualizada com sucesso!', 'success');
                        this.fecharModalEditarPergunta();
                        this.load();
                    } else {
                        avisoErro(res.data?.msg || 'Não foi possível atualizar a solicitação.');
                    }
                } catch (res) {
                    if (res.response?.data?.msg) {
                        avisoErro(res.response.data.msg);
                    } else if (res.response?.data?.errors && res.response.data.errors.length) {
                        avisoErro(res.response.data.errors[0]);
                    } else {
                        avisoErro(res.response?.statusText || 'Erro ao atualizar a solicitação.');
                    }
                } finally {
                    this.salvandoEdicao = false;
                }
            },

            confirmarCancelarPergunta() {
                Swal.fire({
                    title: 'Cancelar solicitação?',
                    text: 'Essa ação não poderá ser desfeita. Para enviar outra pergunta, será necessário abrir uma nova solicitação.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#d33',
                    cancelButtonColor: '#3085d6',
                    confirmButtonText: 'Sim, cancelar',
                    cancelButtonText: 'Voltar'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.cancelarPerguntaUsuario();
                    }
                });
            },

            async cancelarPerguntaUsuario() {
                try {
                    const payload = {
                        idPergunta: this.pergunta.idPergunta,
                    };
                    const res = await axios.post(`${urlApi}/Pergunta/CancelarPeloUsuario`, payload);

                    if (res.data && res.data.success) {
                        avisoToast('Solicitação cancelada com sucesso!', 'success');
                        this.load();
                    } else {
                        avisoErro(res.data?.msg || 'Não foi possível cancelar a solicitação.');
                    }
                } catch (res) {
                    if (res.response?.data?.msg) {
                        avisoErro(res.response.data.msg);
                    } else if (res.response?.data?.errors && res.response.data.errors.length) {
                        avisoErro(res.response.data.errors[0]);
                    } else {
                        avisoErro(res.response?.statusText || 'Erro ao cancelar a solicitação.');
                    }
                }
            },

            load() {
                let $this = this;
                $this.concluido = false;
                axios.get(`${urlApi}/Pergunta/GetPerguntaCompleta/${$this.id}`)
                    .then(res => {
                        $this.concluido = true;
                        if (res.data.success) {
                            var reponse = res.data.data;
                            reponse.dsRespostaIA = (reponse.dsRespostaIA != null ? reponse.dsRespostaIA.replace(/(?:\r\n|\r|\n)/g, "<br>") : null)
                            reponse.dsReferenciaIA = (reponse.dsReferenciaIA != null ? reponse.dsReferenciaIA.replace(/(?:\r\n|\r|\n)/g, "<br>") : null)

                            $this.pergunta = reponse;
                            
                            $this.pergunta.dtPerguntaFormat = moment($this.pergunta.dtPergunta).format('DD/MM/YYYY [às] HH:mm');

                            if ($this.pergunta.dtPrazo) {
                                $this.pergunta.dtPrazoFormat = moment($this.pergunta.dtPrazo).format('DD/MM/YYYY [às] HH:mm');
                            } else {
                                $this.pergunta.dtPrazoFormat = '-';
                            }
                            

                            if ($this.pergunta.perguntaMovimento != null) {
                                $this.pergunta.dtMovimento = moment($this.pergunta.perguntaMovimento.dtMovimento).format('DD/MM/YYYY [às] HH:mm');
                            } else {
                                $this.pergunta.dtMovimento = null;
                            }

                            if ($this.pergunta.tipoPergunta) {
                                $this.pergunta.tipoPergunta.icone = $this.getIconeTipoPergunta($this.pergunta.tipoPergunta.nmTipoPergunta);
                            }

                            if ($this.pergunta.idEtapaAtual == 8) {
                                var flag = true;
                                $this.timer = 0;

                                if (flag) {
                                    flag = false;
                                    $this.intervalTimer = setInterval(function () {
                                        if ($this.timer < 100) {
                                            $this.timer = $this.timer + 1;
                                        } else {
                                            flag = true;
                                            clearInterval($this.intervalTimer);
                                        }
                                    }, 3000);
                                }
                            } else {
                                if ($this.intervalTimer && $this.intervalTimer != null) {
                                    clearInterval($this.intervalTimer);
                                }
                            }

                        } else {
                            avisoErro("Não foi possível a orientação.");
                        }
                    })
                    .catch(res => {
                        $this.concluido = true;
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data.msg);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                        //loading.hide();
                    });
            },

            getIconeTipoPergunta(nmTipoPergunta) {
                switch (nmTipoPergunta) {
                    case 'Estudo Técnico':
                        return 'fas fa-clipboard-list';
                    case 'Resposta Objetiva':
                        return 'far fa-clock';
                    case 'Atendimento Telefônico':
                        return 'fas fa-phone-alt';
                    case 'Atendimento via WhatsApp':
                        return 'fab fa-whatsapp';
                    case 'Mentoria Online':
                        return 'fas fa-laptop';
                    default:
                        return '';
                }
            },

            formatData(data) {
                return moment(data).format('DD/MM/YYYY [às] HH:mm');
            },


            complementaInformacao(idMovimento) {
                let $this = this;
                axios.post(`${urlApi}/PerguntaMovimento/ComplementaInformacao`, { idMovimento: idMovimento, dsMovimento: this.complemento })
                    .then(res => {
                        if (res.data.success) {
                            $this.load();
                        } else {
                            avisoErro("Não foi possível registrar seu complemento.");
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível registrar seu complemento.");
                    })
            },

            mudarPrazo(idPerguntaDilatacaoPrazo, flAceite) {
                alert(idPerguntaDilatacaoPrazo);
                alert(flAceite);
            },


            downloadPerguntaArquivo(idArquivo) {
                let nomeDownload = 'arquivo';

                axios({
                    url: `${urlApi}/Pergunta/DownloadArquivo/${idArquivo}`,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        const href = URL.createObjectURL(response.data);

                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', nomeDownload);
                        document.body.appendChild(link);
                        link.click();

                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(res => {
                        if (res.response && res.response.data && res.response.data.msg) {
                            avisoErro(res.response.data.msg);
                        } else if (res.response && res.response.statusText) {
                            avisoErro(res.response.statusText);
                        } else {
                            avisoErro('Erro ao realizar download do arquivo.');
                        }
                    });
            },

            gerarPdf() {
                if (!this.pergunta || !this.pergunta.dsRespostaIA || this.gerandoPdf) {
                    return;
                }

                this.gerandoPdf = true;
                axios({
                    url: `${urlApi}/Pergunta/DownloadPdf/${this.id}`,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        const href = URL.createObjectURL(response.data);
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', `orientacao_${this.id}.pdf`);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(async (res) => {
                        let mensagem = 'Erro ao gerar PDF';
                        try {
                            const data = res.response && res.response.data;
                            if (data instanceof Blob) {
                                const text = await data.text();
                                try {
                                    const json = JSON.parse(text);
                                    mensagem = json.msg || (json.errors && json.errors[0]) || mensagem;
                                } catch (e) {
                                    mensagem = res.response.statusText || mensagem;
                                }
                            } else if (data && data.msg) {
                                mensagem = data.msg;
                            } else if (res.response && res.response.statusText) {
                                mensagem = res.response.statusText;
                            }
                        } catch (e) {
                            mensagem = (res.response && res.response.statusText) || mensagem;
                        }
                        avisoErro(mensagem);
                    })
                    .finally(() => {
                        this.gerandoPdf = false;
                    });
            },

            async enviaConsultor() {
                try {
                    let payload = {
                        idPergunta: this.pergunta.idPergunta
                    };
                    const res = await axios.post(`${urlApi}/Pergunta/EnviaConsultor`, payload);

                    if (res.data && res.data.success) {
                        avisoToast("Sua Orientação foi encaminhada com sucesso!", "success");
                        this.load(); // recarrega lista e utilizações
                    } else {
                        avisoErro(res.data?.msg || "Não foi possível encaminhar.");
                    }
                } catch (res) {
                    if (res.response?.data !== undefined) {
                        avisoErro(res.response.data);
                    } else {
                        avisoErro(res.response?.statusText || "Erro ao encaminhar pergunta.");
                    }
                }
            },

            async finalizar() {
                try {
                    let payload = {
                        idPergunta: this.pergunta.idPergunta
                    };
                    const res = await axios.post(`${urlApi}/Pergunta/Finalizar`, payload);

                    if (res.data && res.data.success) {
                        avisoToast("Sua Orientação foi finalizada com sucesso!", "success");
                        this.load(); // recarrega lista e utilizações
                    } else {
                        avisoErro(res.data?.msg || "Não foi possível finalizar.");
                    }
                } catch (res) {
                    if (res.response?.data !== undefined) {
                        avisoErro(res.response.data);
                    } else {
                        avisoErro(res.response?.statusText || "Erro ao finalizar pergunta.");
                    }
                }
            },

            InitSignalR() {
                try {
                    let $this = this;

                    $this.hubConection.on("RecebeNotificacaoPergunta", function (idPergunta, status, dtAtualizacao) {
                        if ($this.pergunta.idPergunta == idPergunta) {
                            $this.load();
                        } else {
                            avisoToast('Status da pergunta atualizado para ' + status + ' - ' + dtAtualizacao);
                        }
                    });

                    $this.hubConection.on("AtualizaStatusPergunta", function (idPergunta, status) {
                        if ($this.pergunta.idPergunta == idPergunta) {
                            $this.mensagemProcessando = status;
                        }                        
                    });

                }
                catch (ex) {
                    //console.log(ex);
                }
            },

            formatTexto(txt) {
                if (txt == null)
                    return ''
                return txt.replaceAll("\r\n", "<br />").replaceAll("\n", "<br />").replaceAll("\r", "<br />")
            },

            getNomeArquivo(urlArquivo) {
                if (!urlArquivo) {
                    return 'arquivo';
                }
                const partes = urlArquivo.split('/');
                const nome = partes.length > 0 ? partes[partes.length - 1] : '';
                if (nome && nome.length > 7) {
                    return nome.slice(7);
                }
                return nome || 'arquivo';
            },

            getIconeDocumento(urlArquivo) {
                const nome = (urlArquivo || '').toLowerCase();
                if (nome.endsWith('.pdf')) {
                    return 'fas fa-file-pdf';
                }
                if (nome.endsWith('.doc') || nome.endsWith('.docx')) {
                    return 'fas fa-file-word';
                }
                return 'fas fa-file';
            },

            downloadPerguntaDocumento(item) {
                if (!item || !item.idPerguntaDocumento) {
                    avisoErro('Arquivo não encontrado.');
                    return;
                }

                const nmArquivo = this.getNomeArquivo(item.urlArquivo);

                axios({
                    url: `${urlApi}/Pergunta/DownloadDocumento/${item.idPerguntaDocumento}`,
                    method: 'GET',
                    responseType: 'blob'
                })
                    .then(response => {
                        const href = URL.createObjectURL(response.data);
                        const link = document.createElement('a');
                        link.href = href;
                        link.setAttribute('download', nmArquivo);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(href);
                    })
                    .catch(res => {
                        if (res.response && res.response.data && res.response.data.msg) {
                            avisoErro(res.response.data.msg);
                        } else if (res.response && res.response.statusText) {
                            avisoErro(res.response.statusText);
                        } else {
                            avisoErro('Erro ao realizar download do arquivo.');
                        }
                    });
            }

        },
        mounted() {
            this.load();

            // signalR
            if (this.hubConection != undefined) {
                this.InitSignalR();
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* Container Principal */
    .tyn-section {
        padding: 32px 0;
    }

    .container-fluid {
        max-width: 1400px;
        margin: 0 auto;
    }

    @media (min-width: 1200px) {
        .container-fluid {
            max-width: 1600px;
        }
    }

    /* Header e Navegação */
    .c-pointer {
        cursor: pointer;
        transition: all 0.3s ease;
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 8px 12px;
        border-radius: 8px;
    }

        .c-pointer:hover {
            background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
            transform: translateX(-4px);
        }

    [data-bs-theme="dark"] .c-pointer:hover {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
    }

    /* Cards Modernos */
    .box-borda-cinza {
        background: white;
        border: 1px solid #e5e7eb;
        border-radius: 16px;
        padding: 24px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        margin-bottom: 20px;
    }

    [data-bs-theme="dark"] .box-borda-cinza {
        background: #1f2937;
        border-color: #374151;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }

    .box-borda-cinza:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    [data-bs-theme="dark"] .box-borda-cinza:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
    }

    .box-borda-roxo {
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border: 2px solid #3b82f6;
        border-radius: 16px;
        padding: 24px;
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
    }

    [data-bs-theme="dark"] .box-borda-roxo {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        border-color: #3b82f6;
    }

    /* Status Badges */
    .txt-info {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 16px;
        border-radius: 10px;
        background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
        color: #92400e;
        font-weight: 600;
    }

    .txt-sucess {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 16px;
        border-radius: 10px;
        background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
        color: #065f46;
        font-weight: 600;
    }

    .txt-erro {
        display: inline-flex;
        align-items: center;
        gap: 8px;
        padding: 10px 16px;
        border-radius: 10px;
        background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
        color: #991b1b;
        font-weight: 600;
    }

    [data-bs-theme="dark"] .txt-info {
        background: linear-gradient(135deg, #78350f 0%, #92400e 100%);
        color: #fef3c7;
    }

    [data-bs-theme="dark"] .txt-sucess {
        background: linear-gradient(135deg, #065f46 0%, #047857 100%);
        color: #d1fae5;
    }

    [data-bs-theme="dark"] .txt-erro {
        background: linear-gradient(135deg, #991b1b 0%, #b91c1c 100%);
        color: #fee2e2;
    }

    .piscando {
        animation: piscar 1.5s infinite;
    }

    @keyframes piscar {
        0%, 100% {
            opacity: 1;
        }

        50% {
            opacity: 0.6;
        }
    }

    /* Informações e Andamento */
    .info-andamento {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 12px 0;
    }

        .info-andamento i {
            font-size: 20px;
            color: #2563eb;
            width: 24px;
            text-align: center;
        }

    [data-bs-theme="dark"] .info-andamento i {
        color: #60a5fa;
    }

    /* Áudios */
    .item-arquivo-audio {
        display: flex;
        flex-direction: column;
        gap: 12px;
        padding: 16px;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        transition: all 0.3s ease;
        height: 100%;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }

    [data-bs-theme="dark"] .item-arquivo-audio {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-color: #374151;
    }

    .item-arquivo-audio:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    [data-bs-theme="dark"] .item-arquivo-audio:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
    }

    .item-arquivo-audio span {
        word-wrap: break-word;
        overflow-wrap: break-word;
        max-width: 100%;
        display: block;
    }

    .documentos-pergunta .btn-documento {
        display: inline-flex;
        align-items: center;
        max-width: 100%;
        padding: 8px 12px;
        border: 1px solid #e5e7eb;
        border-radius: 10px;
        background: #fff;
        color: #1e3a8a;
        font-size: 13px;
        font-weight: 600;
        text-align: left;
        transition: all 0.2s ease;
    }

    .documentos-pergunta .btn-documento span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .documentos-pergunta .btn-documento:hover,
    .documentos-pergunta .btn-documento:focus {
        border-color: #2563eb;
        background: #eff6ff;
        color: #1d4ed8;
    }

    [data-bs-theme="dark"] .documentos-pergunta .btn-documento {
        background: #111827;
        border-color: #374151;
        color: #bfdbfe;
    }

    [data-bs-theme="dark"] .documentos-pergunta .btn-documento:hover,
    [data-bs-theme="dark"] .documentos-pergunta .btn-documento:focus {
        border-color: #60a5fa;
        background: #1f2937;
        color: #dbeafe;
    }

    /* Dilatação de Prazo */
    .dilatacao-prazo {
        background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
        border-left: 4px solid #f59e0b;
        border-radius: 12px;
        padding: 20px;
    }

    [data-bs-theme="dark"] .dilatacao-prazo {
        background: linear-gradient(135deg, #78350f 0%, #92400e 100%);
        border-left-color: #f59e0b;
    }

    .dilatacao-prazo .bold,
    .dilatacao-prazo p {
        color: #78350f;
    }

    [data-bs-theme="dark"] .dilatacao-prazo .bold,
    [data-bs-theme="dark"] .dilatacao-prazo p {
        color: #fef3c7;
    }

    .txtApp {
        color: #2563eb;
        font-weight: 600;
    }

    [data-bs-theme="dark"] .txtApp {
        color: #fcd34d;
    }

    [data-bs-theme="dark"] hr {
        border-color: #374151;
        opacity: 1;
    }

    /* Pergunta e Respostas */
    .pergunta {
        padding: 20px;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        border-radius: 12px;
        margin-bottom: 16px;
        border-left: 4px solid #2563eb;
    }

    [data-bs-theme="dark"] .pergunta {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-left-color: #3b82f6;
    }

    [data-bs-theme="dark"] .box-header-modern .pergunta p,
    [data-bs-theme="dark"] .box-header-modern .resposta-rigth p {
        color: #e5e7eb;
    }

    .resposta {
        padding: 16px 20px;
        background: white;
        border-radius: 12px;
        margin-bottom: 16px;
        border-left: 4px solid #10b981;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    [data-bs-theme="dark"] .resposta {
        background: #1f2937;
        border-left-color: #10b981;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
    }

    .resposta-rigth {
        border-left-color: #2563eb;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
    }

    [data-bs-theme="dark"] .resposta-rigth {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
        border-left-color: #3b82f6;
    }

    /* Anotações */
    .item-anotacao {
        padding: 12px 16px;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        border-radius: 8px;
        margin-bottom: 8px;
        border-left: 3px solid #6b7280;
    }

    [data-bs-theme="dark"] .item-anotacao {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-left-color: #9ca3af;
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .item-anotacao .txt-w-bold {
        color: #f9fafb;
    }

    /* Header Section */
    .header-section {
        display: flex;
        align-items: center;
        padding: 16px 0;
    }

    /* Box Header Modern */
    .box-header-modern {
        background: white;
        border: 1px solid #e5e7eb;
        border-radius: 16px;
        padding: 32px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        margin-bottom: 24px;
    }

    [data-bs-theme="dark"] .box-header-modern {
        background: #1f2937;
        border-color: #374151;
    }

    .header-title-section {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        flex-wrap: wrap;
        gap: 24px;
    }

    .page-title {
        font-size: 28px;
        font-weight: 700;
        color: #1f2937;
        margin: 0;
        line-height: 1.3;
        flex: 1;
        min-width: 300px;
    }

    [data-bs-theme="dark"] .page-title {
        color: #f9fafb;
    }

    .modalidade-badge {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 8px;
        min-width: 200px;
    }

    .header-actions {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        gap: 12px;
        min-width: 200px;
    }

    .modalidade-label {
        font-size: 12px;
        font-weight: 600;
        color: #6b7280;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    [data-bs-theme="dark"] .modalidade-label {
        color: #9ca3af;
    }

    .modalidade-value {
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: 600;
        color: #1f2937;
        padding: 8px 16px;
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        border-radius: 8px;
    }

    [data-bs-theme="dark"] .modalidade-value {
        color: #f9fafb;
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
    }

    /* Informações do Usuário */
    .user-info-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 16px;
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        border-radius: 12px;
        margin-bottom: 12px;
        transition: all 0.3s ease;
        word-wrap: break-word;
        overflow-wrap: break-word;
        max-width: 100%;
    }

    [data-bs-theme="dark"] .user-info-item {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
    }

    .user-info-item:hover {
        transform: translateX(4px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .user-info-item i {
        font-size: 20px;
        color: #2563eb;
        margin-top: 4px;
        flex-shrink: 0;
    }

    [data-bs-theme="dark"] .user-info-item i {
        color: #60a5fa;
    }

    .user-info-item > div:last-child {
        flex: 1;
        min-width: 0;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }

    .user-info-item span,
    .user-info-item p {
        word-wrap: break-word;
        overflow-wrap: break-word;
        max-width: 100%;
    }

    /* Botões Modernos */
    .btn-editar-pergunta.btn-outline-primary {
        color: #0d6efd !important;
        background-color: transparent !important;
        border: 1px solid #0d6efd !important;
    }

        .btn-editar-pergunta.btn-outline-primary:hover,
        .btn-editar-pergunta.btn-outline-primary:focus {
            color: #fff !important;
            background-color: #0d6efd !important;
            border-color: #0d6efd !important;
        }

    .textarea-com-contador {
        position: relative;
        margin-bottom: 8px;
    }

        .textarea-com-contador .form-textarea {
            padding-bottom: 28px;
        }

        .textarea-com-contador .form-textarea--excedido {
            border-color: #ef4444;
        }

            .textarea-com-contador .form-textarea--excedido:focus {
                border-color: #ef4444;
                box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.15);
            }

    .char-counter {
        position: absolute;
        right: 12px;
        bottom: 10px;
        pointer-events: none;
        line-height: 1;
    }

    .char-count-text {
        font-size: 11px;
        color: #94a3b8;
        font-weight: 500;
        letter-spacing: 0.2px;
    }

        .char-count-text--excedido {
            color: #ef4444;
            font-weight: 700;
        }

    [data-bs-theme="dark"] .textarea-com-contador .form-textarea--excedido {
        border-color: #ef4444;
    }

    .btn-roxo {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
        border: none;
        border-radius: 10px;
        padding: 10px 20px;
        font-weight: 600;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(37, 99, 235, 0.3);
    }

        .btn-roxo:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(37, 99, 235, 0.4);
            background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
        }

        .btn-roxo:active {
            transform: translateY(0);
        }

        .btn-roxo:disabled {
            opacity: 0.7;
            transform: none;
            box-shadow: none;
            cursor: not-allowed;
        }

    .btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        border: none;
        border-radius: 10px;
        padding: 10px 20px;
        font-weight: 600;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
    }

        .btn-success:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(16, 185, 129, 0.4);
        }

    .btn-vermelho {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
        color: white;
        border: none;
        border-radius: 10px;
        padding: 10px 20px;
        font-weight: 600;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(239, 68, 68, 0.3);
    }

        .btn-vermelho:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 20px rgba(239, 68, 68, 0.4);
        }

    /* Formulário de Complemento */
    .form-control {
        border-radius: 12px;
        border: 2px solid #e5e7eb;
        padding: 12px 16px;
        transition: all 0.2s ease;
    }

    [data-bs-theme="dark"] .form-control {
        background: #1f2937;
        border-color: #374151;
        color: #e5e7eb;
    }

        [data-bs-theme="dark"] .form-control:focus {
            background: #111827;
            border-color: #3b82f6;
            box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.2);
            color: #e5e7eb;
        }

        [data-bs-theme="dark"] .form-control::placeholder {
            color: #6b7280;
        }

    .form-control:focus {
        border-color: #2563eb;
        box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1);
        outline: none;
    }

    [data-bs-theme="dark"] .progress {
        background-color: #374151;
    }

    /* Estado Vazio */
    .empty-state {
        padding: 80px 20px;
        text-align: center;
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
        border-radius: 16px;
    }

    [data-bs-theme="dark"] .empty-state {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
        border: 1px solid #374151;
    }

    /* Títulos e Textos */
    .txt-roxo-1 {
        color: #2563eb;
    }

    [data-bs-theme="dark"] .txt-roxo-1 {
        color: #60a5fa;
    }

    .txt-cores-6 {
        color: #1f2937;
    }

    [data-bs-theme="dark"] .txt-cores-6 {
        color: #f9fafb;
    }

    [data-bs-theme="dark"] .txt-cores-6.txt-w-bold {
        color: #f9fafb;
    }

    .txt-cores-1 {
        color: #6b7280;
    }

    [data-bs-theme="dark"] .txt-cores-1 {
        color: #9ca3af;
    }

    [data-bs-theme="dark"] .txt-cores-1.txt-w-bold {
        color: #d1d5db;
    }

    /* Sidebar Card */
    .sidebar-card {
        background: white;
        border: 1px solid #e5e7eb;
        border-radius: 16px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
        overflow: hidden;
        position: sticky;
        top: 20px;
    }

    [data-bs-theme="dark"] .sidebar-card {
        background: #1f2937;
        border-color: #374151;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }

    .sidebar-section {
        padding: 20px;
        border-bottom: 1px solid #e5e7eb;
    }

    [data-bs-theme="dark"] .sidebar-section {
        border-bottom-color: #374151;
    }

    .sidebar-section:last-child {
        border-bottom: none;
    }

    .pergunta-numero {
        background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
        text-align: center;
        padding: 16px 20px;
    }

    [data-bs-theme="dark"] .pergunta-numero {
        background: linear-gradient(135deg, #1e3a5f 0%, #1e40af 100%);
    }

    /* Info Andamento Compact */
    .info-andamento-compact {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 8px 0;
    }

        .info-andamento-compact i {
            font-size: 16px;
            color: #2563eb;
            width: 20px;
            text-align: center;
            margin-top: 2px;
            flex-shrink: 0;
        }

    [data-bs-theme="dark"] .info-andamento-compact i {
        color: #60a5fa;
    }

    .info-andamento-compact > div {
        flex: 1;
        min-width: 0;
    }

    /* User Info Item Compact */
    .user-info-item-compact {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        padding: 8px 0;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }

        .user-info-item-compact i {
            font-size: 16px;
            color: #2563eb;
            width: 20px;
            text-align: center;
            margin-top: 2px;
            flex-shrink: 0;
        }

    [data-bs-theme="dark"] .user-info-item-compact i {
        color: #60a5fa;
    }

    .user-info-item-compact > div {
        flex: 1;
        min-width: 0;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }

    .user-info-item-compact span,
    .user-info-item-compact p {
        word-wrap: break-word;
        overflow-wrap: break-word;
        max-width: 100%;
    }

    /* Ajustes nos status badges dentro da sidebar */
    .sidebar-section .txt-info,
    .sidebar-section .txt-sucess,
    .sidebar-section .txt-erro {
        font-size: 14px;
        padding: 8px 12px;
        justify-content: center;
        width: 100%;
    }

    /* Responsive */
    @media (max-width: 992px) {
        .header-title-section {
            flex-direction: column;
            align-items: flex-start;
        }

        .modalidade-badge {
            align-items: flex-start;
        }

        .header-actions {
            align-items: flex-start;
        }

        .page-title {
            font-size: 24px;
        }

        .sidebar-card {
            position: static;
            top: 0;
        }
    }

    @media (max-width: 768px) {
        .tyn-section {
            padding: 20px 0;
        }

        .container-fluid {
            padding-left: 16px;
            padding-right: 16px;
        }

        .box-borda-cinza,
        .box-borda-roxo,
        .box-header-modern {
            padding: 16px;
        }

        .info-andamento {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
        }

        .page-title {
            font-size: 20px;
        }

        .header-section {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
        }

        .user-info-item {
            padding: 12px;
        }
    }

    /* Animações */
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    .box-borda-cinza,
    .box-borda-roxo,
    .pergunta,
    .resposta {
        animation: fadeInUp 0.5s ease-out;
    }
</style>

